/**
 * The quiet line a product sync upload surface shows where a drop does more
 * than store a file ("Your first upload here sets this product up"). The
 * counterpart of `LockedHint`: an upload icon and muted text, never the dashed
 * lock, because the cells below it take files (DESIGN.md section 15.2).
 *
 * Presentation only: the caller passes the line, already translated.
 */
import type { ReactNode } from 'react';
import { Upload } from 'lucide-react';
import { cn } from '@/lib/utils';

interface UploadHintProps {
  children: ReactNode;
  className?: string;
}

export function UploadHint({ children, className }: UploadHintProps) {
  return (
    <p className={cn('flex items-start gap-1.5 text-[11px] leading-4 text-muted-foreground', className)}>
      <Upload className="mt-px h-3.5 w-3.5 shrink-0" aria-hidden="true" />
      <span>{children}</span>
    </p>
  );
}
